import styled from 'styled-components';
import { ContentSwiper } from 'src/components/common/Swipers/ContentSwiper';
import { NavigationButton } from 'src/modules/materials/components/ShowcasePage/common';

export const ProductsSwiper = styled(ContentSwiper)`
  justify-content: flex-start;

  .swiper-wrapper {
    height: auto;
  }

  .swiper-slide {
    width: auto;
    display: flex;
  }

  &&& {
    ${NavigationButton} {
      top: 30%;
      transform: translateY(-30%);
      z-index: 9;
    }
  }
`;
